import React, {Component} from 'react';
import {Redirect} from 'react-router';
import ReactDOM from 'react-dom';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as Actions from '../actions';
import Settings from '../lib/settings';
import queryString from 'query-string';

class Cart extends Component {

  constructor(props) {
    super(props);

    let paymentId = queryString.parse(this.props.location.search).id;
    let isOrder = false;

    if (this.props.match.path === "/payment" && typeof paymentId !== "undefined") {
      isOrder = "payment";
    }

    if (typeof this.props.match.params.id !== "undefined") {
      isOrder = "order";
    }

    if (typeof this.props.match.params.paymentId !== "undefined") {
      isOrder = "payment";
      paymentId = this.props.match.params.paymentId;
    }

    this.state = {
      empty: true,
      products: [],
      shipping: [
        {
          name: ""
        }
      ],
      payment: [
        {
          name: ""
        }
      ],
      user: {
        address: {
          city: "",
          street: "",
          postalCode: "",
          country: ""
        },
        email: "",
        name: "",
        surname: ""
      },
      selectedShipping: "default",
      selectedPayment: "default",
      orderId: "",
      orderNumber: "",
      orderStatus: "",
      disabled: false,
      isOrder: isOrder,
      paymentId: paymentId,
      gopayCheckout: false,
      gopayCheckoutId: 0,
      ordered: false
    };
    this.loadPayments = this.loadPayments.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.itemAdd = this.itemAdd.bind(this);
    this.order = this.order.bind(this);
    window.scrollTo(0, this.props.menuPosition);
    this.gopay = window._gopay.checkout.bind(this);
  }

  componentDidMount() {
    this.loadCart();
  }

  handleImageLoaded(event) {
    event.target.classList.remove("imageLoading");
  }

  handleStatusChange(event, id) {

    let order = {
      _id: id,
      status: event.target.value
    }

    fetch("/api/orders/changestatus", Settings.fetchParams('POST', order)).then(res => {
      if (res.ok) {
        res.json().then(json => {

          if (!json.error && json) {

            this.setState({orderStatus: json.status});

          } else {
            alert("Chyba při změně statusu");
          }
        })
      } else {
        alert("Chyba2 při změně statusu");
      }
    });

  }

  loadCart() {

    if (this.state.isOrder === "payment") {
      fetch('/api/orders/payment/' + this.state.paymentId, Settings.fetchParams('GET')).then(res => res.json()).then(json => {
        if (typeof json.products !== "undefined" && json.products !== []) {

          this.setState({
            empty: false,
            products: json.products,
            selectedPayment: 0,
            selectedShipping: 0,
            payment: [json.payment],
            shipping: [json.shipping],
            orderId: json._id,
            orderStatus: json.status,
            user: json.user,
            orderNumber: json.orderNumber
          });

        } else {
          this.setState({empty: true});
        }
      });
    } else if (!this.state.isOrder) {
      fetch('/api/cartdetail/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {
        //this.props.dispatch(Actions.loader(false));
        if (typeof json.products !== "undefined" && json.products !== []) {
          this.setState({empty: false, products: json.products});
        } else {
          this.setState({empty: true});
        }
      });

      fetch('/api/shipping/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {
        //this.props.dispatch(Actions.loader(false));
        if (typeof json !== "undefined" && typeof json.error === "undefined") {
          this.setState({shipping: json});
        }

      });

      this.loadPayments("shipping");
      fetch('/api/cart', Settings.fetchParams('GET')).then(res => res.json().then(json => {

        if (typeof json.products !== "undefined") {
          this.props.dispatch(Actions.updateCart(json.products));
        }
      }));

    } else {
      fetch('/api/orders/' + this.props.match.params.id, Settings.fetchParams('GET')).then(res => res.json()).then(json => {

        if (typeof json.products !== "undefined" && json.products !== []) {

          this.setState({
            empty: false,
            products: json.products,
            selectedPayment: 0,
            selectedShipping: 0,
            payment: [json.payment],
            shipping: [json.shipping],
            orderId: json._id,
            orderStatus: json.status,
            user: json.user,
            orderNumber: json.orderNumber
          });

        } else {
          this.setState({empty: true});
        }
      });
    }

  }

  loadPayments(shipping) {
    fetch('/api/payment/', Settings.fetchParams('GET')).then(res => res.json()).then(json => {
      //this.props.dispatch(Actions.loader(false));
      if (typeof json !== "undefined" && typeof json.error === "undefined" && json.length > 0) {
        this.setState({payment: json});
      } else {
        this.setState({disabled: true});
      }

    });
  }

  itemAdd(index, amount) {
    let product = {
      _id: this.state.products[index]._id,
      price: this.state.products[index].price,
      amount: amount,
      slug: this.state.products[index],
      parameters: this.state.products[index].parameters
    };

    //this.props.dispatch(Actions.addToCart(product));

    fetch("/api/cart", Settings.fetchParams('POST', product)).then(res => {
      if (res.ok) {
        res.json().then(json => {

          if (!json.error && json.products) {
            this.props.dispatch(Actions.updateCart(json.products));
            this.loadCart();

          } else {
            alert("Chyba při přidávání do košíku");
          }
        })
      } else {
        alert("Chyba2 při přidávání do košíku");
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    //this.loadCart();
    if (typeof this.props.match.params.paymentId !== "undefined") {
      this.loadCart();
      let isOrder = "payment";
      let paymentId = this.props.match.params.paymentId;
      this.setState({isOrder: isOrder, paymentId: paymentId});
    }
  }

  handleChange(event) {

    this.setState({
      [event.target.name]: event.target.value
    });

    if (event.target.name === "selectedShipping") {
      this.setState({selectedPayment: "default"});
    }

  }

  order(total, shippingPrice, paymentPrice) {
    if (!this.state.ordered) {
      this.setState({ordered: true});
      if (this.state.selectedPayment === "default" || this.state.selectedShipping === "default") {
        alert("Prosím vyberte dopravu a platbu");
      } else {

        let products = this.state.products.map((item, index) => {
          return {
            _id: item._id,
            name: item.name,
            amount: item.amount,
            discount: item.discount,
            originalPrice: item.originalPrice,
            price: item.price,
            parameters: item.parameters,
            slug: item.slug,
            images: item.images
          }
        });

        let order = {
          products: products,
          shipping: this.state.shipping[this.state.selectedShipping],
          payment: this.state.payment[this.state.selectedPayment],
          total: total,
          shippingPrice: shippingPrice,
          paymentPrice: paymentPrice,
          status: "pending",
          user: this.props.user
        }

        fetch("/api/orders", Settings.fetchParams('POST', order)).then(res => {
          if (res.ok) {
            res.json().then(json => {

              if (!json.error && json._id) {

                fetch('/api/emptycart/', Settings.fetchParams('GET')).then(res2 => res2.json()).then(json2 => {
                  if (typeof json2 !== "undefined" && typeof json2.error === "undefined" && json2) {

                    if (typeof json.payment.name !== "undefined" && json.payment.name === "Kartou") {

                      fetch("/api/gopay/create", Settings.fetchParams('POST', json)).then(res3 => res3.json()).then(json3 => {

                        this.gopay({
                          gatewayUrl: json3.gw_url,
                          inline: true
                        }, (checkoutResult) => {
                          this.setState({
                            gopayCheckout: true,
                            paymentId: checkoutResult.id,
                            isOrder: "payment"
                          }, () => {
                            this.props.history.push('/payment/' + checkoutResult.id)
                            this.loadCart();
                          });

                        });
                      });

                    } else {
                      this.loadCart();
                      window.scrollTo(0, this.props.menuPosition);
                      ReactDOM.findDOMNode(this.refs.cart).innerHTML = '<div class="emptyCart"><div><h2 class="addSuccess">Vaše objednávka byla uložena. Děkujeme.</h2></div></div>';
                    }

                  }
                });

              } else {
                alert("Chyba při vytváření objednávky");
              }
            })
          } else {
            alert("Chyba2 při vytváření objednávky");
          }
        });

      }
    }
  }

  render() {
    //
    // if(this.state.gopayCheckout) {
    //   return <Redirect to={"/payment/" + this.state.gopayCheckoutId}/>;
    // }

    let itemsTotal = 0;

    const cartItems = this.state.products.map((item, index) => {

      itemsTotal += item.price * item.amount;
      const Parameters = [];
      if (typeof item.parameters !== "undefined") {
        item.parameters.forEach((item2, index2) => {
          Parameters.push(<p key={index2}>
            <strong>{item2.name}:
            </strong>{item2.value}</p>);
        });
      }

      return (<div key={index} className="cartItem">
        <div className="cartItemImg">
          <div className="squareContent">
            <img src={"/img/products/" + item.images[0].replace(/(\.[\w\d_-]+)$/i, '_thumb$1')} alt={item.name} className="imageLoading" onLoad={this.handleImageLoaded}/>
          </div>
        </div>
        <div className="itemsDescriptionWrapper">
          <div className="itemName">
            <Link to={"/product/" + item.slug}>{item.name}</Link>
            <div className="itemParameters">{Parameters}</div>
          </div>
          <div className="itemAmount">
            <span>Množství:
            </span>{item.amount}
            {
              !this.state.isOrder
                ? <div className="amountArrows">
                    <i className="fas fa-arrow-circle-up" onClick={() => {
                        this.itemAdd(index, 1)
                      }}></i>
                    <i className="fas fa-arrow-circle-down" onClick={() => {
                        this.itemAdd(index, -1)
                      }}></i>
                  </div>
                : <span>&nbsp;</span>
            }

          </div>
          <div className="itemPrice">
            <span>Cena za KS:
            </span>{parseFloat(item.price).toLocaleString()}
            Kč</div>
          <div className="itemPrice">
            <span>Cena za celkem:
            </span>{(item.price * item.amount).toLocaleString()}
            Kč</div>

        </div>
        <div className="itemRemove">
          {
            !this.state.isOrder
              ? <i className="fas fa-trash-alt" onClick={() => {
                    this.itemAdd(index, "remove")
                  }}></i>
              : <span>&nbsp;</span>
          }

        </div>
      </div>)
    });

    const ShippingPrice = (onlyNumber) => {
      if (this.state.selectedShipping === "default") {
        return "";
      } else {
        if (onlyNumber) {
          return parseFloat(this.state.shipping[this.state.selectedShipping].price) === 0 || (itemsTotal >= parseFloat(this.state.shipping[this.state.selectedShipping].free) && parseFloat(this.state.shipping[this.state.selectedShipping].free) !== 0)
            ? 0
            : parseFloat(this.state.shipping[this.state.selectedShipping].price);
        } else {
          return parseFloat(this.state.shipping[this.state.selectedShipping].price) === 0 || (itemsTotal >= parseFloat(this.state.shipping[this.state.selectedShipping].free) && parseFloat(this.state.shipping[this.state.selectedShipping].free) !== 0)
            ? "Zdarma"
            : parseFloat(this.state.shipping[this.state.selectedShipping].price).toLocaleString() + " Kč";
        }

      }
    };

    const PaymentPrice = (onlyNumber) => {

      if (this.state.selectedPayment === "default") {
        return "";
      } else {
        if (onlyNumber) {
          return parseFloat(this.state.payment[this.state.selectedPayment].price) === 0 || (itemsTotal >= parseFloat(this.state.payment[this.state.selectedPayment].free) && parseFloat(this.state.payment[this.state.selectedPayment].free) !== 0)
            ? 0
            : parseFloat(this.state.payment[this.state.selectedPayment].price);
        } else {
          return parseFloat(this.state.payment[this.state.selectedPayment].price) === 0 || (itemsTotal >= parseFloat(this.state.payment[this.state.selectedPayment].free) && parseFloat(this.state.payment[this.state.selectedPayment].free) !== 0)
            ? "Zdarma"
            : parseFloat(this.state.payment[this.state.selectedPayment].price).toLocaleString() + " Kč";
        }

      }
    };

    const CartTotalWithShipping = () => {

      let superTotal = itemsTotal;

      if (typeof this.state.selectedShipping !== "undefined" && this.state.selectedShipping !== "default" && typeof this.state.shipping[this.state.selectedShipping].price !== "undefined" && itemsTotal < parseFloat(this.state.shipping[this.state.selectedShipping].free)) {
        superTotal += parseFloat(this.state.shipping[this.state.selectedShipping].price);
      }

      if (typeof this.state.selectedPayment !== "undefined" && this.state.selectedPayment !== "default" && typeof this.state.payment[this.state.selectedPayment].price !== "undefined" && itemsTotal < parseFloat(this.state.payment[this.state.selectedPayment].free)) {
        superTotal += parseFloat(this.state.payment[this.state.selectedPayment].price);
      }

      return superTotal;

    }

    const ShippingList = this.state.shipping.map((item, index) => <option key={index} value={index}>{item.name + " "}
      - {
        (parseFloat(item.price) === 0 || (parseFloat(item.free) <= itemsTotal && parseFloat(item.free) !== 0))
          ? "Zdarma"
          : item.price + " Kč"
      }</option>);

    const PaymentList = [];

    if (this.state.selectedShipping !== "default" && typeof this.state.shipping[this.state.selectedShipping] !== "undefined") {
      this.state.payment.forEach((item, index) => {
        if (this.state.shipping[this.state.selectedShipping].payments.includes(item._id)) {
          PaymentList.push(<option key={index} value={index}>{item.name + " "}
            - {
              (parseFloat(item.price) === 0 || (parseFloat(item.free) <= itemsTotal && parseFloat(item.free) !== 0))
                ? "Zdarma"
                : item.price + " Kč"
            }</option>);
        }
      });
    }

    const ShippingDescription = () => {
      if (typeof this.state.selectedShipping !== "undefined" && this.state.selectedShipping !== "default" && typeof this.state.shipping[this.state.selectedShipping].description !== "undefined") {
        return (<div className="description">{this.state.shipping[this.state.selectedShipping].description}</div>);
      } else {
        return "";
      }

    }

    const PaymentDescription = () => {
      if (typeof this.state.selectedPayment !== "undefined" && this.state.selectedPayment !== "default" && typeof this.state.payment[this.state.selectedPayment].description !== "undefined") {
        return (<div className="description">{this.state.payment[this.state.selectedPayment].description}</div>);
      } else {
        return "";
      }

    }

    const statusSwitch = (param) => {
      switch (param) {
        case 'pending':
          return 'Čeká';
        case 'inProcess':
          return 'Vyřizuje se';
        case 'payed':
          return 'Zaplacena';
        case 'shipped':
          return 'Odeslána';
        case 'cancelled':
          return 'Stornována';
        case 'waitingForPayment':
          return 'Čeká na zaplacení';
        default:
          return '-';
      }
    }

    if (!this.state.isOrder && this.state.disabled) {
      return <Redirect to="/"/>;
    }

    return this.props.cart.items.length < 1 && !this.state.isOrder
      ? (<div className="emptyCart">
        <div>
          <h2>Košík je prázdný</h2>
        </div>
      </div>)
      : (<div ref="cart">
        <div className="productDetails">
          <div className="col100">
            <div className="articleWrapper">
              <h2>{
                  !this.state.isOrder
                    ? "Košík"
                    : <div>
                        <h3 className="paymentMessage">Děkujeme za objednávku.</h3>
                        <span>Objednávka - č. {this.state.orderNumber}
                          {
                            this.props.admin
                              ? <select value={this.state.orderStatus} onChange={(e) => {
                                    this.handleStatusChange(e, this.state.orderId)
                                  }}>

                                  <option value="pending">Čeká</option>
                                  <option value="inProcess">Vyřizuje se</option>
                                  <option value="payed">Zaplacena</option>
                                  <option value="shipped">Odeslána</option>
                                  <option value="ready">Připravena k vyzvednutí</option>
                                  <option value="cancelled">Stornována</option>
                                </select>
                              : <span>
                                  {statusSwitch(this.state.orderStatus)}</span>

                          }<span className="orderId">(Id: {this.state.orderId})</span>
                        </span>
                        <div className="orderUser">
                          <h3>Objednal:</h3>
                          <p>
                            <strong>Jméno a příjmení:
                            </strong>
                            {this.state.user.name}
                            {this.state.user.surname}</p>
                          <p>
                            <strong>Adresa:
                            </strong>
                            {this.state.user.address.street}, {this.state.user.address.city}
                            - {this.state.user.address.postalCode}, {this.state.user.address.country}</p>
                          <p>
                            <strong>Email:
                            </strong>
                            {this.state.user.email}
                          </p>
                        </div>
                      </div>
                }</h2>
                {
                    !this.state.isOrder
                      ? <div className="cartInfo">Při objednávce nad 2000Kč doprava zdarma!</div>
                      : ""
                  }
              <div className="cartItemsWrapper">
                <div className="cartItemsHeading">
                  <div className="cartItemImg"></div>
                  <div className="itemsDescriptionWrapper">
                    <div className="itemName">Produkty</div>
                    <div className="itemAmount">Množství</div>
                    <div className="itemPrice">Cena za KS</div>
                    <div className="itemPrice">Cena celkem</div>

                  </div>{
                    !this.state.isOrder
                      ? <div className="itemRemove">X</div>
                      : <span>&nbsp;</span>
                  }
                </div>
                {cartItems}

              </div>

              {
                !this.props.auth
                  ? <div>
                      <Link to="/login/cart" className="loginButton">Přihlásit
                        <i className="fas fa-sign-in-alt"></i>
                      </Link>
                      <Link to="/signup/cart" className="signupButton">
                        <i className="fas fa-user-plus"></i>Registrovat

                      </Link>
                    </div>
                  : <div>
                      <div className="shippingPayingSelector">
                        <div className="row">
                          <div className="col33">
                            <i className="fas fa-truck"></i>Způsob dopravy:
                          </div>
                          <div className="col33">
                            {
                              !this.state.isOrder
                                ? <select value={this.state.selectedShipping} onChange={this.handleChange} name="selectedShipping" ref="selectedShipping">
                                    <option disabled="disabled" value="default">Vyberte</option>
                                    {ShippingList}</select>
                                : <span>{this.state.shipping[0].name}</span>
                            }
                          </div>
                          <div className="col33">{ShippingPrice()}</div>
                        </div>
                        {ShippingDescription()}
                      </div>

                      <div className="shippingPayingSelector paymentHeight" style={{
                          opacity: this.state.selectedShipping !== "default"
                            ? 1
                            : 0
                        }}>
                        <div className="row">
                          <div className="col33">
                            <i className="fas fa-coins"></i>Způsob platby:
                          </div>
                          <div className="col33">
                            {
                              !this.state.isOrder
                                ? <select value={this.state.selectedPayment} onChange={this.handleChange} name="selectedPayment" ref="selectedPayment">
                                    <option disabled="disabled" value="default">Vyberte</option>{PaymentList}</select>
                                : <span>{this.state.payment[0].name}</span>
                            }
                          </div>
                          <div className="col33">{PaymentPrice()}</div>
                        </div>
                        {PaymentDescription()}
                      </div>

                      <div className="cartTotal">
                        <p>Cena celkem:
                          <strong>
                            {" " + CartTotalWithShipping().toLocaleString() + " "}
                          </strong>
                          Kč</p>
                      </div>

                      {
                        !this.state.isOrder
                          ? <div className="orderButton" onClick={() => {
                                this.order(CartTotalWithShipping(), ShippingPrice(true), PaymentPrice(true))
                              }}>Objednat
                              <i className="fas fa-cart-arrow-down"></i>
                            </div>
                          : <span>&nbsp;</span>
                      }

                    </div>
              }
            </div>
          </div>
        </div>
      </div>);
  }
}
function mapStateToProps(state) {
  return {admin: state.admin, auth: state.auth, user: state.user, menuPosition: state.menuPosition, cart: state.cart};
}
export default withRouter(connect(mapStateToProps)(Cart));



// WEBPACK FOOTER //
// ./src/pages/Cart.js